import * as React from 'react';
import {FullscreenLoader} from '../FullscreenLoader';
import {QueryProvider} from '../QueryProvider';
import {GET_REGIONS} from '../../graphql/RegionQueries';

export interface RegionProviderProps {
  /** Pass fetched regions to children component as callback */
  children: (data: any) => JSX.Element;
}

export const RegionProvider: React.FC<RegionProviderProps> = ({children}) => (
  <QueryProvider query={GET_REGIONS} loader={<FullscreenLoader />}>
    {({regions}: {regions: Array<Region>}) => {
      const sortedRegions = regions ? regions.sort((a: Region, b: Region) => (a.name < b.name ? -1 : 1)) : [];

      return children(sortedRegions);
    }}
  </QueryProvider>
);



// WEBPACK FOOTER //
// ./src/components/RegionProvider/RegionProvider.tsx